import Base from '@/clients/base'

const mutations = {
  setUnreadTicketsCount (state, count) {
    state.count = count
  },

  incrementUnreadTicketsCount (state) {
    state.count += 1
  },

  decrementUnreadTicketsCount (state) {
    state.count = Math.max(0, state.count - 1)
  }
}

const getters = {
  unreadTicketsCount (state) {
    return state.count
  }
}

const actions = {
  async fetchUnreadCount ({ commit }) {
    try {
      const { data } = await Base._get(`${Base.apiUrl}/support_tickets/counts`, { scope: 'unread' })
      commit('setUnreadTicketsCount', data?.data?.count ?? 0)
    } catch (_err) {
      // Fail silently — badge stays at 0
    }
  }
}

export default {
  state: {
    count: 0
  },
  actions,
  getters,
  mutations
}
